console.log('[FE_v] V 1.0.7');
/* --- REQUIRED Validator --- */
import { FE$BaseValidator, FEngineException } from './v2-fgen-fengine.js'
function FE$RequiredValidator() { }
FE$RequiredValidator.prototype = new FE$BaseValidator();

FE$RequiredValidator.prototype.getType = function () {
   return 'required';
}
FE$RequiredValidator.prototype.validate = function (value, configuration, translationSvc, lang) {
   console.log('[FE$RequiredValidator] Executing validate using default implementation');
   console.log('[FE$RequiredValidator] Checking value ' + value)
   if (!value || value.length == 0) {
      console.log('[FE$RequiredValidator] Not valid!')
      var msg = configuration.message;
      if (!configuration.message) {
         msg = 'Value is empty'
      }
      var ret = translationSvc(msg, lang);
      console.log('[FE$RequiredValidator] Not valid message: "' + ret + '"')
      return ret;
   }
   console.log('[FE$RequiredValidator] VALID!')
   return null;
}

/* --- REQUIRED + CHOICE + AUTOCOMPLETE --- */
function FE$RequiredForChoiceAutocompleteValidator() { }
FE$RequiredForChoiceAutocompleteValidator.prototype = new FE$BaseValidator();
FE$RequiredForChoiceAutocompleteValidator.prototype.getType = function () {
   return 'required';
}
FE$RequiredForChoiceAutocompleteValidator.prototype.getForControl = function () {
   return 'choice';
}
FE$RequiredForChoiceAutocompleteValidator.prototype.getForVariant = function () {
   return 'autocomplete';
}

FE$RequiredForChoiceAutocompleteValidator.prototype.validate = function (value, configuration, translationSvc, lang) {
   console.log('[FE$RequiredForChoiceAutocompleteValidator] Invoking validation...dummy');
   var require = configuration.require
   if (!require || 'value' === require) {
      var vvalue = value ? value[''] : null
      if (!vvalue) {
         var msg = configuration.message;
         if (!msg) {
            msg = 'Value is empty'
         }
         var ret = translationSvc(msg, lang);
         console.log('[FE$RequiredValidator] Returning not valid message: "' + ret + '"')
         return ret;
      }
   } else if ('text' === require) {
      var tvalue = value ? value['text'] : null
      if (!tvalue) {
         var msg = configuration.message;
         if (!msg) {
            msg = 'Value is empty'
         }
         var ret = translationSvc(msg, lang);
         console.log('[FE$RequiredValidator] Returning not valid message: "' + ret + '"')
         return ret;
      }
   }
   return null;
}

/* --- REQUIRED + INVITATIONS Validator --- */
function FE$Required4InvitationValidator() { }
FE$Required4InvitationValidator.prototype = new FE$BaseValidator();

FE$Required4InvitationValidator.prototype.getType = function () {
   return 'required';
}
FE$Required4InvitationValidator.prototype.getForControl = function () {
   return 'invitation';
}
FE$Required4InvitationValidator.prototype.validate = function (value, configuration, translationSvc, lang) {
   var gs = value[''];

   // When the sessions are grouped we need to validate each session 
   if (gs.bySessions) {
      return this.validateBySessions(gs, configuration, translationSvc, lang);
   }

   console.log('[FE$Required4InvitationValidator] Executing validate using CUSTOM invitation implementation');
   console.log('[FE$Required4InvitationValidator] Checking value ' + JSON.stringify(value));

   /* Example value
   {
      "":[
         {"id":"id1","label":"Presentació molt avorrida","assistants":["2","3"]},
         {"id":"id2","label":"Banquet del quinze (?)","assistants":["2","3"]}
      ],"friendly":"Presentació molt avorrida [2(Adults)+3(Nens)];Banquet del quinze (?) [2(Adults)+3(Nens)]"}
   
   */


   // Calculate assistance
   var attendees = 0;
   for (var i = 0; i < gs.attendees.length; i++) {
      attendees += gs.attendees[i];
   }

   if ('minAttendees' in configuration) {
      console.log('[FE$Required4InvitationValidator] Checking min attendees: ' + configuration.minAttendees + ' vs ' + attendees);
      if (configuration.minAttendees > attendees) {
         var msg = configuration.message;
         if (!configuration.message) {
            msg = 'Value is empty'
         }
         return translationSvc(msg, lang);
      }
   }


   if ('maxAttendees' in configuration) {
      console.log('[FE$Required4InvitationValidator] Checking max attendees: ' + configuration.maxAttendees + ' vs value ' + attendees);
      if (configuration.maxAttendees < attendees) {
         var msg = configuration.message;
         if (!configuration.message) {
            msg = 'Value is empty'
         }
         return translationSvc(msg, lang);
      }
   }


   if ('minSessions' in configuration) {
      console.log('[FE$Required4InvitationValidator] Checking min sessions');
      if (configuration.minSessions > gs.sessions.length) {
         var msg = configuration.message;
         if (!configuration.message) {
            msg = 'Value is empty'
         }
         return translationSvc(msg, lang);
      }
   }

   if ('maxSessions' in configuration) {
      console.log('[FE$Required4InvitationValidator] Checking max sessions');
      if (configuration.maxSessions < gs.sessions.length) {
         var msg = configuration.message;
         if (!configuration.message) {
            msg = 'Value is empty'
         }
         return translationSvc(msg, lang);
      }
   }

   console.log('[FE$Required4InvitationValidator] VALID!')
   return null;
}

/**
 * Validates the invitation component by session.
 * 
 * @param {*} value The result value of the component
 * @param {*} validDef Validation definition
 * @param {*} translate Function to translate the error message
 * @param {*} lang of the message
 * @returns the error message or null 
 */

FE$Required4InvitationValidator.prototype.validateBySessions = function (value, validDef, translate, lang) {
   //Ok, if isn't required ends
   if (validDef.type != 'required') return null;

   // The min and max Attendees needs an iteration over the sessions
   if (validDef.minAttendees || validDef.maxAttendees) {

      for (let i in value.bySessions) {
         let session = value.bySessions[i];

         // check over each session the min and max number of attendees
         if (validDef.minAttendees &&
            (parseInt(session.attendees[0], 10) + parseInt(session.attendees[1], 10)) < validDef.minAttendees) {
            return translate(validDef.message, lang);
         } else if (validDef.maxAttendees &&
            (parseInt(session.attendees[0], 10) + parseInt(session.attendees[1], 10)) > validDef.maxAttendees) {
            return translate(validDef.message, lang);
         }
      }

      return null;
      // check if there are more sessions than permitted
   } else if (validDef.maxSessions && value.bySessions.length > validDef.maxSessions) {
      return translate(validDef.message, lang);
      // check if there are less sessions than permitted
   } else if (validDef.minSessions && value.bySessions.length < validDef.minSessions) {
      return translate(validDef.message, lang);
   }

   //Here we are, so valid!
   return null;
}

/* --- REGEX Validator --- */
function FE$RegexValidator() { }
FE$RegexValidator.prototype = new FE$BaseValidator();

FE$RegexValidator.prototype.getType = function () {
   return 'regex';
}
FE$RegexValidator.prototype.validate = function (value, configuration, translationSvc, lang) {
   console.log('[FE$RegexValidator] Executing validate');
   console.log('[FE$RegexValidator] Checking value "' + value + '"')
   if (!("regex" in configuration)) {
      throw new FEngineException('No regex property for validation');
   }
   var regex = new RegExp(configuration.regex, 'g');
   value = value ? value : '';
   console.log('[FE$RegexValidator] Validating regex: "' + configuration.regex + '"" against "' + value + '"')
   if (!regex.test(value)) {
      console.log('[FE$RegexValidator] Not valid!')
      var msg = configuration.message;
      if (!configuration.message) {
         msg = 'Value is empty'
      }
      var ret = translationSvc(msg, lang);
      console.log('[FE$RegexValidator] Not valid message: "' + ret + '"')
      return ret;
   }
   console.log('[FE$RequiredValidator] VALID!')
   return null;
}


/* --- REQUIREDIF Validator --- */
function FE$RequiredIfValidator() { }
FE$RequiredIfValidator.prototype = new FE$BaseValidator();

FE$RequiredIfValidator.prototype.getType = function () {
   return 'reqif';
}
FE$RequiredIfValidator.prototype.validate = function (value, configuration, translationSvc, lang) {
   console.log('[FE$RequiredIfValidator] Executing validate');
   console.log('[FE$RequiredIfValidator] Checking value ' + value)

   if (!("other" in configuration)) {
      throw new FEngineException('No other field informed in validation');
   }
   var otherVal = this.getValueProvider()(configuration.other);
   console.log('[FE$RequiredIfValidator] Validating other value: ' + otherVal);

   var valid = true
   if (configuration.othervalue != null && configuration.othervalue != undefined) {
      if (otherVal === configuration.othervalue && !value) {
         console.log('[FE$RequiredIfValidator] Other value for validation matches: ' + otherVal + ' and value is empty ' + value)
         valid = false;
      }
   } else if (!otherVal) {
      console.log('[FE$RequiredIfValidator] Other value for validation is empty')
      valid = false;
   }

   var ret = null;
   if (!valid) {
      var errMsg = configuration.message;
      if (!configuration.message) {
         errMsg = 'Value is required'
      }
      ret = translationSvc(errMsg);
   }

   return ret;
}

/* --- ValidDate Validator --- */
function FE$ValidDateValidator() { }
FE$ValidDateValidator.prototype = new FE$BaseValidator();

FE$ValidDateValidator.prototype.getType = function () {
   return 'validdate';
}

FE$ValidDateValidator.prototype._parseDate = function (s) {

   // s is the result of `toString` method
   const parts = s.split('/');
   const day = parseInt(parts[0], 10);
   const month = parseInt(parts[1], 10) - 1;
   var year = parseInt(parts[2], 10);
   if (year < 50) {
      year += 2000;
   } else if (year > 50 && year < 100) {
      year += 1900;
   }
   return new Date(year, month, day);
}

FE$ValidDateValidator.prototype._calcDate = function (defDate) {
   if (!defDate) {
      return null;
   }
   var re = new RegExp('today\\s*([\\+-])\\s*([0-9]+)([dmyw])', 'gm');

   var ret = null;
   var m = null;
   var today = new Date();
   if (defDate == 'today') {
      ret = today;
   } else if ((m = re.exec(defDate))) {
      console.log('[FER_Date] Match with ' + defDate);
      var op = m[1];
      var sAmount = m[2];
      var amount = parseInt(sAmount, 10);
      var unit = m[3];
      if (unit == 'y') {
         ret = new Date(today.getFullYear() + (op == '+' ? amount : -amount), today.getMonth(), today.getDate());
      } else if (unit == 'm') {
         ret = new Date(today.getFullYear(), today.getMonth() + (op == '+' ? amount : -amount), today.getDate());
      } else if (unit == 'd') {
         ret = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (op == '+' ? amount : -amount));
      } else if (unit == 'w') {
         ret = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (op == '+' ? amount : -amount) * 7);
      }

   } else if (/[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{2,4}/.test(defDate)) {
      ret = this._parseDate(defDate);
   }

   return ret;

}

FE$ValidDateValidator.prototype.validate = function (value, configuration, translationSvc, lang) {
   console.log('[FE$ValidDateValidator] Executing validate');
   console.log('[FE$ValidDateValidator] Checking value ' + value)

   var valid = true;
   if (value == null) {
      console.log('[FE$ValidDateValidator] Returning null value valid');
      return null;
   }
   if (/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/.test(value)) {

      var v = value.replace(/\//gi, '');
      var day = parseInt(v.substring(0, 2), 10);
      var month = parseInt(v.substring(2, 4), 10) - 1;
      var year = parseInt(v.substring(4, 8), 10);
      var dt = new Date(year, month, day, 0, 0, 0, 0);

      var aDay = dt.getDate();
      var aMonth = dt.getMonth();
      var aYear = dt.getFullYear();

      if (aDay != day || aMonth != month || aYear != year) {
         valid = false;
      }
      if (valid && 'minDate' in configuration) {

         var minDt = this._calcDate(configuration.minDate);
         if (minDt.getTime() > dt.getTime()) {
            console.log('[FE$ValidDateValidator] Date is before min date');
            valid = false;
         }
      }
      if (valid && 'maxDate' in configuration) {
         var maxDt = this._calcDate(configuration.maxDate);
         if (maxDt.getTime() < dt.getTime()) {
            console.log('[FE$ValidDateValidator] Date is after max date');
            valid = false;
         }
      }
   } else {
      valid = false;
   }
   var ret = null;
   console.log('[FE$ValidDateValidator] Valid date "' + value + '" is valid?' + valid);
   if (!valid) {
      var errMsg = configuration.message;
      if (!configuration.message) {
         errMsg = 'Value is required'
      }
      ret = translationSvc(errMsg);
   }

   return ret;
}

/* --- MaxSize 4 Upload Validator --- */
function FE$MaxSizeForUploadValidator() { }
FE$MaxSizeForUploadValidator.prototype = new FE$BaseValidator();

FE$MaxSizeForUploadValidator.prototype.getType = function () {
   return 'maxsize';
}

FE$MaxSizeForUploadValidator.prototype.getForControl = function () {
   return 'upload';
}

FE$MaxSizeForUploadValidator.prototype.validate = function (value, configuration, translationSvc, lang) {
   console.log('[FE$MaxSizeForUploadValidator] Executing validate');
   console.log('[FE$MaxSizeForUploadValidator] Checking value ', value)
   var errMsg = null;
   var max = configuration.size
   for (var i = 0; i < value.length; i++) {
      if (value[i].size > max) {
         errMsg = translationSvc(configuration.message, lang).replace(/\{0}/, value[i].file);
         break;
      }
   }
   console.log('[FE$MaxSizeForUploadValidator] Error message returned: ' + errMsg);

   return errMsg;
}

/* --- Type 4 Upload Validator --- */
function FE$TypeForUploadValidator() { }
FE$TypeForUploadValidator.prototype = new FE$BaseValidator();

FE$TypeForUploadValidator.prototype.getType = function () {
   return 'type';
}

FE$TypeForUploadValidator.prototype.getForControl = function () {
   return 'upload';
}

FE$TypeForUploadValidator.prototype.validate = function (value, configuration, translationSvc, lang) {
   console.log('[FE$TypeForUploadValidator] Executing validate');
   console.log('[FE$TypeForUploadValidator] Checking value ', value)
   var errMsg = null;

   for (var i = 0; i < value.length; i++) {
      var valid = false;
      for (var j = 0; j < configuration.types.length; j++) {
         var re = new RegExp(configuration.types[j], 'ig');
         if (re.test(value[i].type)) {
            valid = true;
            break;
         }
      }
      if (!valid) {
         errMsg = translationSvc(configuration.message, lang).replace(/\{0}/, value[i].file);
         break;
      }
   }
   console.log('[FE$TypeForUploadValidator] Error message returned: ' + errMsg);

   return errMsg;
}

/* --- Number of Options Validator --- */
function FE$NumOptionsValidator() { }
FE$NumOptionsValidator.prototype = new FE$BaseValidator();

FE$NumOptionsValidator.prototype.getType = function () {
   return 'numoptions';
}

FE$NumOptionsValidator.prototype.getForControl = function () {
   return 'multichoice';
}

FE$NumOptionsValidator.prototype.validate = function (value, configuration, translationSvc, lang) {
   console.log('[FE$NumOptionsValidator] Executing validate');
   console.log('[FE$NumOptionsValidator] Checking value ', value)
   var errMsg = null;

   if (value == null || typeof value != 'object' || !('array' in value)) {
      throw new FEngineException('No valid value validated. Is validator configured on multichoice?');
   }
   var arrLength = value.array.length;
   if ('min' in configuration && arrLength < configuration.min) {
      console.log('[FE$NumOptionsValidator] min validation failed: ' + arrLength + ' vs ' + configuration.min);
      errMsg = translationSvc(configuration.message, lang)
   } else if ('max' in configuration && arrLength > configuration.max) {
      console.log('[FE$NumOptionsValidator] max validation failed: ' + arrLength + ' vs ' + configuration.max);
      errMsg = translationSvc(configuration.message, lang)
   }

   console.log('[FE$NumOptionsValidator] Error message returned: ' + errMsg);

   return errMsg;
}

function FE$TimeValidator() { }
FE$TimeValidator.prototype = new FE$BaseValidator();

FE$TimeValidator.prototype.getType = function () {
   return 'timePar';
}
FE$TimeValidator.prototype.validate = function (value, configuration, translationSvc, lang) {

   if (parseInt(value.split(':')[1]) % 2 != 0) {
      var msg = configuration.message;
      var ret = translationSvc(msg, lang);
      return ret;
   }
   return null;
}

fe$ngine.register(FE$TimeValidator);

/* ---- REGISTRATIONS ---- */
fe$ngine.register(FE$RequiredValidator);
fe$ngine.register(FE$RegexValidator);
fe$ngine.register(FE$RequiredIfValidator);
fe$ngine.register(FE$RequiredForChoiceAutocompleteValidator);
fe$ngine.register(FE$Required4InvitationValidator);
fe$ngine.register(FE$ValidDateValidator);
fe$ngine.register(FE$MaxSizeForUploadValidator);
fe$ngine.register(FE$TypeForUploadValidator);
fe$ngine.register(FE$NumOptionsValidator);
fe$ngine.register(FE$TimeValidator);